import { useLocale } from 'containers/App/LocaleContext';
import { FieldArray, type FormikProps, FormikProvider } from 'formik';
import type { JSX } from 'react';
import { GraphFirstHopEntryPoint } from './GraphFirstHopEntryPoint';
import type { MulticastFormValues } from './MulticastFormValues';
import type { UnicastFormValues } from './UnicastFormValues';

interface Props<TFormikValues> {
  formik: FormikProps<TFormikValues>;
}

export const GraphFirstHopEntryPoints = <
  TFormikValues extends MulticastFormValues | UnicastFormValues,
>(
  props: Props<TFormikValues>,
): JSX.Element => {
  const {
    canvasGraph: {
      graphSidePanel: {
        pathlookup: { entryPoints: entryPointsMsg },
      },
    },
  } = useLocale();

  return (
    <FormikProvider value={props.formik}>
      <FieldArray
        name='entryPoints'
        render={(arrayHelpers) => (
          <>
            <div className='flex'>
              <label className='form__label w-32' htmlFor={undefined}>
                {entryPointsMsg.hostname}
              </label>
              <label className='form__label' htmlFor={undefined}>
                {entryPointsMsg.iface}
              </label>
            </div>
            {props.formik.values.entryPoints.map((_hop, index) => (
              <GraphFirstHopEntryPoint
                // biome-ignore lint/suspicious/noArrayIndexKey: no better key
                key={index}
                index={index}
                formik={props.formik}
                arrayHelpers={arrayHelpers}
              />
            ))}
          </>
        )}
      />
    </FormikProvider>
  );
};
